import {
  Box,
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import ThriveTitle from "../../common/ThriveTitle";
import { StyledButtonMain } from "../../common/Buttons";
import { useContext, useState } from "react";
import { UserContext } from "../../../context/UserContext";
import ThriveModal from "../../common/ThriveModal";
import WebIntakeAssign from "./WebIntakeAssign";
import { axiosInstance } from "../../../utils/networking";

const formatValue = (value: unknown) => {
  if (value === null || value === undefined || value === "") {
    return "—";
  }

  if (Array.isArray(value)) {
    return value.join(", ");
  }

  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  return String(value);
};

const hiddenFields = new Set(["_id", "Entry ID", "source"]);

const WebIntakeDetail = (props: any) => {
  const [assignToOpen, setAssignToOpen] = useState(false);
  const { user } = useContext(UserContext);
  const { submission } = props;
  const details = submission
    ? Object.entries(submission).filter(([key]) => !hiddenFields.has(key))
    : [];

  const handleDelete = () => {
    axiosInstance.delete(`/webintake/${submission["_id"]}`).then(() => {
      props.setOpen(false);
    });
  };

  return (
    <Box>
      <ThriveTitle
        setOpen={props.setOpen}
        title="Web Intake Form Detail"
      ></ThriveTitle>

      {details.length ? (
        <Box sx={{ height: 580, overflow: "auto" }}>
          <TableContainer>
            <Table size="small" stickyHeader>
              <TableBody>
                {details.map(([label, value]) => (
                  <TableRow key={label} sx={{ verticalAlign: "top" }}>
                    <TableCell
                      sx={{
                        width: { xs: "40%", md: "30%" },
                        fontWeight: 600,
                        color: "text.secondary",
                      }}
                    >
                      {label}
                    </TableCell>
                    <TableCell sx={{ whiteSpace: "pre-line" }}>
                      {formatValue(value)}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : (
        <Typography variant="body1" color="text.secondary">
          No submission details available.
        </Typography>
      )}
      {props.actionMode && (
        <>
          <Stack
            direction="row"
            spacing={5}
            justifyContent="center"
            sx={{ mt: 3 }}
          >
            {user.role === "admin" && (
              <StyledButtonMain
                variant="contained"
                color="primary"
                onClick={() => setAssignToOpen(true)}
              >
                Assign
              </StyledButtonMain>
            )}
            <StyledButtonMain
              variant="outlined"
              color="error"
              onClick={handleDelete}
            >
              Delete
            </StyledButtonMain>
          </Stack>
          <></>
          <ThriveModal
            open={assignToOpen}
            setOpen={setAssignToOpen}
            closeByClick={true}
            height={700}
            contentComponent={
              <WebIntakeAssign
                setAssignToOpen={setAssignToOpen}
                currUser={user}
                entryId={submission["Entry ID"]}
              />
            }
          ></ThriveModal>
        </>
      )}
    </Box>
  );
};

export default WebIntakeDetail;
